import axios from "axios";

//@TODO: add timeouts
const appRequest = {
  getAllPilots: () => {
    let url = `https://api.airtable.com/v0/appjWVRPyLcHPAz0A/Pilots`;
    //&filterByFormula=OR(SEARCH(LOWER("${searchString}"),LOWER({part number})),SEARCH(LOWER("${searchString}"),LOWER({secondary part number})),SEARCH(LOWER("${searchString}"),LOWER({Product Name})))`
    return axios({
      url: url,
      method: "GET",
      headers: {
        Authorization: "Bearer keycN2U7BBmQfMvw8",
      },
    })
      .then((resp) => {
        // console.log("axios all pilot: ", resp.data.records);
        const fields = resp.data.records;
        let obj = {};
        let array = [];
        fields.forEach((element) => {
          obj[element["id"]] = element["fields"];
          element["fields"].id = element["id"];
          array.push(element["fields"]);
        });
        //console.log(array);
        //console.log(obj);//
        return new Promise((resolve, reject) => {
          resolve({ responsObj: obj, dataStatus: "ready", responseAry: array });
        });
      })
      .catch((error) => {
        return Promise.reject({ request: "getAllAircraft", error: error, status: "network_error" });
      });
  },
};

export default appRequest;
